import React, { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomSelect from "../input/select";
import "./modal.scss";
// import CustomeInput from "../input/input";
import { InputLabel } from "@material-ui/core";
import { hasDangerousCode } from "../../utils/utils";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import Chip from "@mui/material/Chip";
import classNames from "classnames";

const Input = ({
  name,
  error,
  validation,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  showLabel,
  label,
  readonly,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        {showLabel && (
          <InputLabel
            className={classNames(
              classes.selectInputLabel,
              `selectInputLabel_${tableName}`,
            )}
            htmlFor={name}
            style={{ fontSize: "13px", outline: "none", marginBottom: "3px" }}
          >
            {label === null || label === undefined ? "None" : label}
          </InputLabel>
        )}
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={2}
          style={{
            width: "100%",
            marginBottom: "-20px",
            fontSize: "13px",
            padding: "2px",
            outline: "none",
            border: `${readonly ? "1px solid #cccccc" : "1px solid black"}`,
            borderRadius: "5px",
            color: `${readonly ? "#46596a" : "black"}`,
          }}
          name={name}
          value={value || ""}
          onChange={handleOnChange}
          disabled={readonly}
        />
        <p className={classNames(classes.error, `error${tableName}`)}>
          {hasError && error}
        </p>
      </div>
    </>
  );
};

const CustomeInput = ({
  name,
  label,
  showLabel,
  error,
  validation,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  readonly,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const handleOnChange = (e) => {
    const newValue = e.target.value;

    const allowed = props.onChange(name, newValue);

    // ❌ STOP updating internal state if rejected
    if (allowed === false) return;

    setInputValue(e.target.value);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <InputLabel
          className={classNames(
            classes.selectInputLabel,
            `selectInputLabel_${tableName}`,
          )}
          htmlFor={name}
          style={{ fontSize: "12px", marginBottom: "2px" }}
        >
          {label}
        </InputLabel>
        <input
          className={classNames(
            classes.input,
            `input${tableName}`,
            "custom-input-field",
          )}
          style={{
            borderBottom: `${
              readonly ? "1px solid #cccccc" : "1px solid #4a4a4a"
            }`,
            color: `${readonly ? "#46596a" : "black"}`,
            fontSize: "13px",
          }}
          name={name}
          value={inputValue}
          onChange={handleOnChange}
          disabled={readonly}
        />
        <p className={classNames(classes.error, `error${tableName}`)}>
          {hasError && error}
        </p>
      </div>
    </>
  );
};

export default function ViewRecord(props) {
  const {
    sourceData,
    updateAlert,
    updateSourceInputs,
    isRowDataUpdating,
    setIsRowDataUpdating,
    handleUpdateRow,
  } = props;
  const [mode, setMode] = useState(props?.readOnly);
  const [rowData, setRowData] = useState(props?.modelData?.rowData || {});
  const [mapColumnState, setMapColumnState] = useState({});

  const [rowHasError, setRowHasError] = useState(false);
  const [editedRowData, setEditedRowData] = useState({});
  const wholeRowData = props?.modelData || {};

  const DROPDOWN_DATA = sourceData?.data?.dropdown || {};
  const DROPDOWN_VALUES = DROPDOWN_DATA?.dropdown_values || {};
  const EDIT_MODEL_COLUMN_LIST = DROPDOWN_DATA?.edit_column_model_list || [];
  const Ignore_columns_for_create_new =
    DROPDOWN_DATA?.ignore_columns_for_create_new || [];
  const Key_value_pair_columns_list =
    DROPDOWN_DATA?.key_value_pair_columns_list || [];

  const [customStyles, setCustomStyles] = useState({
    menuPortal: (base) => ({
      ...base,
      maxHeight: "90%",
      fontSize: 12,
      fontFamily: "Hind Siliguri !important",
      zIndex: 9999,
    }),
  });

  const handleClose = () => {
    props.closeModel();
    setMapColumnState({});
    // setMode(true);
  };

  const handleEdit = (e) => {
    setMode(false);
  };

  const handleValidate = () => {
    return true;
  };

  const handleOnSelectChange = (key, val) => {
    const isArray = Array.isArray(val);
    const formattedValue = isArray
      ? val
          .filter(Boolean) // remove null / undefined
          .map((item) =>
            typeof item === "object" ? (item.value ?? item.label) : item,
          )
      : (val ?? "");

    const updatedData = Object.assign({}, rowData, {
      [key]: formattedValue,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [key]: formattedValue,
    }));
    setRowData(updatedData);
  };

  const handleInputOnChange = (key, val) => {
    const ColumnValue = val || "";
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    const updatedData = Object.assign({}, rowData, {
      [key]: val,
    });
    setEditedRowData((prev) => ({
      ...prev,
      [key]: val,
    }));
    setRowData(updatedData);
    return true;
  };

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const checkRowDataUpdateStatus = () => {
    let result = false;

    sourceData.current_mapped_data.forEach((item) => {
      if (item.item_Id === wholeRowData?.item_Id) {
        // Condition Check for New Data
        if (wholeRowData?.isNewData) {
          // Step 1: Check if all editData fields are null
          const allFieldsNull =
            sourceData.data.dropdown.mandatory_column_details.some(
              (editItem) => {
                return wholeRowData?.rowData?.[editItem] === null;
              },
            );

          if (allFieldsNull) {
            // Step 2: Check Mandatory column values in rowData are non-null
            const allFieldsNotNull =
              sourceData.data.dropdown.mandatory_column_details.every((key) => {
                return rowData?.[key] !== null && rowData?.[key]?.length !== 0;
              });
            result = allFieldsNotNull;
          } else {
            // Step 3: Check if any value has updated
            const anyFieldChanged = EDIT_MODEL_COLUMN_LIST.some((key) => {
              return rowData?.[key.name] !== wholeRowData?.rowData?.[key.name];
            });
            result = anyFieldChanged;
          }
        } else {
          // Condition Checks for Existing Data
          // Step 1: Check is any values are changed
          const Is_Not_Updated = Object.keys(wholeRowData?.rowData).every(
            (key) => rowData?.[key] === wholeRowData?.rowData?.[key],
          );

          if (Is_Not_Updated) {
            result = false;
          } else {
            result = true;
          }
        }
      }
    });

    return result;
  };

  const checkIsNoDuplicateData = () => {
    const DUPLICATE_VALIDATION_ATTRIBUTES =
      sourceData?.data?.dropdown?.duplicate_validation_attributes;
    return sourceData?.current_mapped_data?.every((item) => {
      const Existing_Data = item?.rowData || {};
      //If same rowData no need to check ignore it
      if (item.item_Id === wholeRowData.item_Id) return true;
      // If not the same rowData then check the condition
      const result = DUPLICATE_VALIDATION_ATTRIBUTES.every((attribute) => {
        if (
          Existing_Data?.[attribute] === null &&
          rowData?.[attribute] === null
        )
          return true;
        return Existing_Data?.[attribute] === rowData?.[attribute];
      });

      return !result;
    });
  };

  const handleSave = async (e) => {
    setRowHasError(false);

    // CHECKS CHANGES MADE IN RECORD
    const is_Value_Changed = EDIT_MODEL_COLUMN_LIST.some((item) => {
      return rowData?.[item.name] !== wholeRowData?.rowData?.[item.name];
    });
    if (!is_Value_Changed) {
      wholeRowData?.isNewData
        ? updateAlert({
            open: true,
            message: "Values cannot be Empty",
            severity: "error",
            closeFlag: true,
          })
        : updateAlert({
            open: true,
            message: "No Value has been changed",
            severity: "error",
            closeFlag: true,
          });
      return;
    }

    const isNewDataUpdate = checkRowDataUpdateStatus();
    if (!isNewDataUpdate) {
      updateAlert({
        open: true,
        message: "Mandatory columns needs to be filled",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    const Is_No_Duplicate_Data = checkIsNoDuplicateData();
    if (!Is_No_Duplicate_Data) {
      updateAlert({
        open: true,
        message: "Cannot add duplicate entries",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    const IsColumnValueValid = EDIT_MODEL_COLUMN_LIST?.every((item) => {
      const value = rowData?.[item.name];
      const dropdownValues =
        typeof value === "object"
          ? DROPDOWN_VALUES?.[item.name]?.keys || []
          : DROPDOWN_VALUES?.[item.name] || [];

      // Skip empty/null values
      if (!value || value === "null" || dropdownValues?.length === 0)
        return true;

      let isProperValue = false;
      if (typeof value === "object") {
        isProperValue = Object.keys(value)?.every((key) =>
          dropdownValues.includes(key),
        );
      } else {
        isProperValue = dropdownValues.some((val) => val === value);
      }
      return isProperValue;
    });
    if (!IsColumnValueValid) {
      updateAlert({
        open: true,
        message: "Column values are invalid",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    let updatedArray;
    const DUPLICATE_VALIDATION_ATTRIBUTES =
      sourceData?.data?.dropdown?.duplicate_validation_attributes;
    if (wholeRowData.isNewData) {
      const MODIFIED_MAPPED_DATA = sourceData?.modified_mapped_data || [];

      const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
        const updated = item?.updated || {};
        return DUPLICATE_VALIDATION_ATTRIBUTES.every((key) => {
          return updated?.[key] === wholeRowData?.rowData?.[key];
        });
      });

      if (isAlreadyEdited) {
        const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
          const updated = item?.updated || {};
          const isEditedRowData = DUPLICATE_VALIDATION_ATTRIBUTES.every(
            (key) => {
              return updated?.[key] === wholeRowData?.rowData?.[key];
            },
          );

          if (isEditedRowData) {
            return {
              actual: {},
              updated: rowData,
              isNew: true,
              isEdited: false,
            };
          } else {
            return item;
          }
        });

        updatedArray = Updated_Modified_data;
      } else {
        const Updated_Modified_Data = [
          {
            actual: {},
            updated: rowData,
            isNew: wholeRowData?.isNewData,
            isEdited: false,
          },
          ...MODIFIED_MAPPED_DATA,
        ];
        updatedArray = Updated_Modified_Data;
      }
    } else {
      const MODIFIED_MAPPED_DATA = sourceData?.modified_mapped_data || [];

      const isAlreadyEdited = MODIFIED_MAPPED_DATA.some((item) => {
        const updated = mergeWithObj2Priority(
          wholeRowData?.rowData,
          item.updated,
        );
        return DUPLICATE_VALIDATION_ATTRIBUTES.every((key) => {
          return updated?.[key] === wholeRowData?.rowData?.[key];
        });
      });

      if (isAlreadyEdited) {
        const Updated_Modified_data = MODIFIED_MAPPED_DATA.map((item) => {
          const updated = mergeWithObj2Priority(
            wholeRowData?.rowData,
            item.updated,
          );
          const isEditedRowData = DUPLICATE_VALIDATION_ATTRIBUTES.every(
            (key) => {
              return updated?.[key] === wholeRowData?.rowData?.[key];
            },
          );

          if (isEditedRowData) {
            return {
              actual: item.actual,
              updated: { ...item.updated, ...rowData },
              isNew: false,
              isEdited: true,
            };
          } else {
            return item;
          }
        });

        updatedArray = Updated_Modified_data;
      } else {
        const COMBINED_UPDATED_DATA = mergeWithObj2Priority(
          wholeRowData?.rowData,
          rowData,
        );
        const Updated_Modified_Data = [
          ...MODIFIED_MAPPED_DATA,
          {
            actual: {
              ...wholeRowData?.rowData,
            },
            updated: {
              ...COMBINED_UPDATED_DATA,
            },
            isNew: false,
            isEdited: true,
          },
        ];
        updatedArray = Updated_Modified_Data;
      }
    }

    //Updating the redux store with final result
    const updated = sourceData?.current_mapped_data?.map((item) =>
      item.item_Id === wholeRowData?.item_Id
        ? {
            ...item,
            isEdited: true,
            isEditing: false,
            isValidated: true,
            rowData: rowData,
          }
        : item,
    );

    updateSourceInputs("current_mapped_data", updated);
    updateSourceInputs("modified_mapped_data", updatedArray);
    updateSourceInputs("any_row_isEditing", false);

    setIsRowDataUpdating(true);
    await handleUpdateRow(rowData);

    handleClose();
  };

  const formattedData = (data) => {
    // Case 1: Array (your existing logic)
    if (Array.isArray(data)) {
      return data
        .map((item, index) => {
          if (item?.key && item?.value !== undefined) {
            const formattedValue = String(item.value)
              .split(/\s*,\s*/)
              .map((v) => v.trim())
              .join(",");

            return `${index + 1}) ${item.key} : ${formattedValue}`;
          }
          return "";
        })
        .filter(Boolean)
        .join("\n");
    }

    // Case 2: Object
    if (data && typeof data === "object") {
      return Object.entries(data)
        .map(([key, value], index) => {
          const formattedValue = String(value)
            .split(/\s*,\s*/)
            .map((v) => v.trim())
            .join(", ");

          return `${index + 1}) ${key} : ${formattedValue}`;
        })
        .join("\n");
    }

    return "";
  };

  const removeAttributeFromObjectTypeCol = (attribute, itemName) => {
    let updated = {};
    Object.keys(rowData?.[itemName]).forEach((item) => {
      if (item !== attribute) {
        const key = item;
        const value = rowData?.[itemName]?.[key] || "";
        updated = {
          ...updated,
          [key]: value,
        };
      }
    });

    const Final = {
      ...rowData,
      [itemName]: updated,
    };
    setRowData(Final);
  };

  const updateKeyForAddNewAttributeMethod = (columnName, key) => {
    setMapColumnState((prev) => ({
      ...prev,
      [columnName]: {
        key,
        value: "",
      },
    }));
  };

  const updateValueForAddNewAttributeMethod = (columnName, value) => {
    setMapColumnState((prev) => ({
      ...prev,
      [columnName]: {
        ...(prev[columnName] || {}),
        value,
      },
    }));
  };

  const addNewAttributeToObjectTypeCol = (index, itemName) => {
    const columnState = mapColumnState?.[itemName] || {};
    const CURRENT_KEY = columnState?.key?.value || "";
    const CURRENT_VALUE =
      typeof columnState?.value === "string"
        ? columnState.value.trim()
        : columnState?.value;

    // Validation - Empty key
    if (!CURRENT_KEY && CURRENT_KEY.length === 0) {
      return;
    }

    // Validation - Empty value
    if (
      CURRENT_VALUE === undefined ||
      CURRENT_VALUE === null ||
      CURRENT_VALUE === "" ||
      CURRENT_VALUE.length === 0
    ) {
      updateAlert({
        open: true,
        message: "Please enter a value",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    const Same_Key_Not_Exists =
      rowData?.[itemName] && Object.keys(rowData?.[itemName]).length > 0
        ? Object.keys(rowData?.[itemName])?.every((key) => key !== CURRENT_KEY)
        : true;

    if (!Same_Key_Not_Exists) {
      updateAlert({
        open: true,
        message: "The selected key already exists",
        severity: "error",
        closeFlag: true,
      });
      setMapColumnState((prev) => ({
        ...prev,
        [itemName]: {
          key: {},
          value: "",
        },
      }));
      return;
    }

    const SORTED_ATTRIBUTE_LIST = {
      ...rowData?.[itemName],
      [CURRENT_KEY]: CURRENT_VALUE?.split(",") || null,
    };
    const Final = {
      ...rowData,
      [itemName]: SORTED_ATTRIBUTE_LIST,
    };
    setRowData(Final);
    setMapColumnState((prev) => ({
      ...prev,
      [itemName]: {
        key: {},
        value: "",
      },
    }));
  };

  useEffect(() => {
    setRowData(wholeRowData?.rowData || {});
    setMode(props?.readOnly);
  }, [props.modelData]);

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={props.openModel}
        onClose={handleClose}
        scroll="paper"
        PaperProps={{
          sx: {
            height: "90vh",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle>{props?.heading || ""}</DialogTitle>
        <DialogContent
          dividers
          sx={{
            flex: 1,
            overflowY: "auto",
          }}
        >
          <DialogContentText>
            {/* NORMAL COLUMNS */}
            <div className="table-fields-container">
              {EDIT_MODEL_COLUMN_LIST &&
                EDIT_MODEL_COLUMN_LIST?.filter(
                  (item) =>
                    !Ignore_columns_for_create_new.includes(item?.name || ""),
                ).map((item, index) => {
                  const SELECT_OPTIONS =
                    DROPDOWN_VALUES &&
                    Object.keys(DROPDOWN_VALUES)?.length > 0 &&
                    DROPDOWN_VALUES?.[item.name]
                      ? DROPDOWN_VALUES?.[item.name] || []
                      : [];
                  return (
                    <div className="table-fields-select" key={`model-${index}`}>
                      {item.isEditable ? (
                        item.type === "select" ? (
                          <CustomSelect
                            classes={{
                              ...props.selectClasses,
                            }}
                            tableName={props.tableName}
                            name={item.name}
                            onChange={(e) =>
                              handleOnSelectChange(item.name, e.target.value)
                            }
                            options={SELECT_OPTIONS}
                            customStyles={customStyles}
                            value={
                              rowData[item.name] &&
                              typeof rowData[item.name] === "object"
                                ? JSON.stringify(rowData[item.name])
                                : rowData[item.name] || ""
                            }
                            error={item.error}
                            selectMessage={item.label}
                            validation={item.validation}
                            readonly={mode}
                          />
                        ) : item.type === "multi_select" ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                              gap: "3px",
                              width: "100%",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#5d6063",
                              }}
                            >
                              {item.label}
                            </label>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              disabled={mode}
                              options={SELECT_OPTIONS?.filter(Boolean) || []}
                              value={
                                rowData[item.name] === null ||
                                rowData[item.name] === "null"
                                  ? []
                                  : typeof rowData[item.name] === "string"
                                    ? rowData[item.name]
                                        .split(/\s*,\s*/)
                                        .map((v) => v.trim())
                                    : Array.isArray(rowData[item.name])
                                      ? rowData[item.name]
                                      : []
                              }
                              onChange={(e, newValue) => {
                                handleOnSelectChange(item.name, newValue);
                              }}
                              getOptionLabel={(option) => option}
                              isOptionEqualToValue={(option, value) =>
                                option === value
                              }
                              renderOption={(props, option, { selected }) => (
                                <li {...props} style={{ fontSize: "13px" }}>
                                  <Checkbox
                                    checked={selected}
                                    sx={{
                                      padding: "2px",
                                      transform: "scale(0.9)",
                                    }}
                                  />
                                  {option}
                                </li>
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    label={option}
                                    size="small"
                                    {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              sx={{
                                width: "275px",

                                "& .MuiOutlinedInput-root": {
                                  alignItems: "flex-start",
                                  paddingTop: "4px",
                                  paddingBottom: "4px",

                                  // ✅ default border
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: mode ? "#cccccc" : "black",
                                  },

                                  // ✅ hover
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: mode ? "#cccccc" : "black",
                                  },

                                  // ✅ focus
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: mode ? "#cccccc" : "black",
                                    },
                                },

                                "& .MuiAutocomplete-inputRoot": {
                                  flexWrap: "wrap", // 🔥 important for chips
                                },

                                "& .MuiAutocomplete-tag": {
                                  margin: "2px",
                                },

                                "& input": {
                                  marginTop: "4px",
                                },
                              }}
                              slotProps={{
                                popper: {
                                  sx: {
                                    "& .MuiAutocomplete-listbox": {
                                      fontSize: "13px", // 🔥 controls overall list font
                                    },
                                    "& .MuiAutocomplete-option": {
                                      fontSize: "13px", // 🔥 each option text
                                      padding: "4px 8px", // optional: tighter spacing
                                    },
                                  },
                                },
                              }}
                            />
                          </div>
                        ) : item.type === "input" ? (
                          <CustomeInput
                            columnDataArr={rowData[item.name]}
                            tableName={props.tableName}
                            showLabel={false}
                            classes={{ ...props.inputClasses }}
                            type={item.type}
                            name={item.name}
                            label={item.label}
                            onChange={handleInputOnChange}
                            value={
                              rowData[item.name] &&
                              typeof rowData[item.name] === "object"
                                ? JSON.stringify(rowData[item.name])
                                : rowData[item.name] || ""
                            }
                            item={item.name}
                            error={item.error}
                            validation={item.validation}
                            childHasError={(bool) => setRowHasError(bool)}
                            readonly={mode}
                          />
                        ) : item.type === "textarea" ? (
                          <Input
                            columnDataArr={rowData[item.name]}
                            tableName={props.tableName}
                            classes={{}}
                            showLabel={false}
                            label={item.label}
                            type={item.type}
                            name={item.name}
                            onChange={(e) =>
                              handleInputOnChange(item.name, e.target.value)
                            }
                            value={
                              rowData[item.name] &&
                              typeof rowData[item.name] === "object"
                                ? JSON.stringify(rowData[item.name])
                                : rowData[item.name] || ""
                            }
                            item={item.name}
                            childHasError={(bool) => setRowHasError(bool)}
                            error={item?.error || ""}
                            validation={handleValidate}
                            readonly={mode}
                          />
                        ) : (
                          <CustomeInput
                            columnDataArr={rowData[item.name]}
                            tableName={props.tableName}
                            showLabel={false}
                            classes={{ ...props.inputClasses }}
                            type={item.type}
                            name={item.name}
                            label={item.label}
                            onChange={handleInputOnChange}
                            value={
                              rowData[item.name] &&
                              typeof rowData[item.name] === "object"
                                ? JSON.stringify(rowData[item.name])
                                : rowData[item.name] || ""
                            }
                            item={item.name}
                            error={item.error}
                            validation={item.validation}
                            childHasError={(bool) => setRowHasError(bool)}
                            readonly={true}
                          />
                        )
                      ) : (
                        <CustomeInput
                          columnDataArr={rowData[item.name]}
                          tableName={props.tableName}
                          showLabel={false}
                          classes={{ ...props.inputClasses }}
                          type={item.type}
                          name={item.name}
                          label={item.label}
                          onChange={handleInputOnChange}
                          value={
                            rowData[item.name] &&
                            typeof rowData[item.name] === "object"
                              ? JSON.stringify(rowData[item.name])
                              : rowData[item.name] || ""
                          }
                          item={item.name}
                          error={item.error}
                          validation={item.validation}
                          childHasError={(bool) => setRowHasError(bool)}
                          readonly={true}
                        />
                      )}
                    </div>
                  );
                })}
            </div>

            {/* KEY VALUE PAIR COLUMNS */}
            <div style={{ marginTop: "10px" }}>
              {EDIT_MODEL_COLUMN_LIST &&
                EDIT_MODEL_COLUMN_LIST?.filter((item) =>
                  Key_value_pair_columns_list?.includes(item?.name || ""),
                ).map((item, index) => {
                  return (
                    <div>
                      {/* LABEL */}
                      <h3
                        style={{
                          fontSize: "13px",
                          color: "#5d6063",
                          marginTop: "32px",
                        }}
                      >
                        {item?.label || ""}
                      </h3>

                      {/* CONTENT */}
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          marginTop: "16px",
                        }}
                      >
                        {/* TABS */}
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "13px",
                              color: `${mode ? "#46596a" : "black"}`,
                              padding: "4px 4px",
                              width: "400px",
                              minHeight: "45px",
                              border: `1px solid ${mode ? "#cccccc" : "black"}`,
                              height: "fit-content",
                              borderRadius: "5px",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {formattedData(rowData?.[item.name]) || ""}
                          </p>
                        </div>

                        {/* EDIT BAR */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          {/* EXISTING ATTRIBUTE DROPDOWNS START */}
                          {rowData?.[item.name] &&
                            Object.keys(rowData[item.name])?.length > 0 &&
                            Object.keys(rowData[item.name])?.map(
                              (attribute, index) => {
                                // --- KEY OPTIONS ---
                                const KEY = {
                                  label: attribute,
                                  value: attribute,
                                };
                                const KEY_OPTIONS =
                                  DROPDOWN_VALUES &&
                                  Object.keys(DROPDOWN_VALUES)?.length > 0 &&
                                  DROPDOWN_VALUES?.[item.name]?.keys?.length > 0
                                    ? DROPDOWN_VALUES?.[item.name].keys
                                    : [];

                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "start",
                                      gap: "8px",
                                      marginLeft: "20px",
                                      width: "550px",
                                      height: "fit-content",
                                    }}
                                  >
                                    {/* KEY */}
                                    <div style={{ width: "100%" }}>
                                      <Autocomplete
                                        disableClearable
                                        options={KEY_OPTIONS || []}
                                        value={KEY}
                                        getOptionLabel={(option) =>
                                          option.label || ""
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.value === value.value
                                        }
                                        renderOption={(
                                          props,
                                          option,
                                          { selected },
                                        ) => {
                                          return (
                                            <li {...props}>{option.label}</li>
                                          );
                                        }}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => (
                                            <Chip
                                              key={option.value}
                                              label={option.label}
                                              {...getTagProps({ index })}
                                              size="small"
                                            />
                                          ))
                                        }
                                        sx={{
                                          fontSize: "13px", // base font size

                                          "& .MuiInputBase-root": {
                                            padding: "2px 10px 2px 10px",
                                            height: "45px",
                                            fontSize: "13px",

                                            // ✅ default border
                                            "& .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: mode
                                                  ? "#cccccc"
                                                  : "black",
                                              },

                                            // ✅ hover
                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: mode
                                                  ? "#cccccc"
                                                  : "black",
                                              },

                                            // ✅ focus
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: mode
                                                  ? "#cccccc"
                                                  : "black",
                                              },
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontSize: "14px",
                                          },
                                          "& .MuiAutocomplete-endAdornment": {
                                            top: "calc(100% - 22px)", // center the dropdown icon
                                          },
                                        }}
                                        slotProps={{
                                          popper: {
                                            sx: {
                                              "& .MuiAutocomplete-paper": {
                                                boxShadow:
                                                  "0 2px 8px rgba(0,0,0,0.15)",
                                                borderRadius: "8px",
                                              },
                                              "& .MuiAutocomplete-listbox": {
                                                padding: "4px 0",
                                                fontSize: "12px",
                                              },
                                              "& .MuiAutocomplete-option": {
                                                padding: "4px 6px",
                                                margin: "0px 4px",
                                                borderRadius: "2px",
                                                cursor: "pointer",
                                                transition:
                                                  "background 0.15s ease",
                                              },
                                              "& .MuiAutocomplete-option:hover":
                                                {
                                                  backgroundColor: "#f0f0f0",
                                                },
                                              "& .MuiAutocomplete-option[aria-selected='true']":
                                                {
                                                  backgroundColor:
                                                    "transparent !important",
                                                },
                                              "& .MuiAutocomplete-option.Mui-focused":
                                                {
                                                  backgroundColor:
                                                    "#f5f5f5 !important",
                                                },
                                            },
                                          },
                                        }}
                                        open={false} // 👈 force close always
                                        onOpen={(e) => e.stopPropagation()} // block opening
                                        readOnly
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            inputProps={{
                                              ...params.inputProps,
                                              readOnly: true,
                                            }}
                                            style={{ border: "none" }}
                                          />
                                        )}
                                      />
                                    </div>
                                    <span style={{ width: "10px" }}>:</span>
                                    {/* VALUE */}
                                    <div style={{ width: "100%" }}>
                                      <Input
                                        columnDataArr={rowData?.[item.name]}
                                        tableName={props.tableName}
                                        classes={{}}
                                        showLabel={false}
                                        label={item.label}
                                        type={item.type}
                                        name={item.name}
                                        onChange={(e) =>
                                          handleInputOnChange(
                                            item.name,
                                            e.target.value,
                                          )
                                        }
                                        value={
                                          rowData?.[item.name] &&
                                          typeof rowData?.[item.name] ===
                                            "object"
                                            ? rowData?.[item.name]?.[
                                                attribute
                                              ] || ""
                                            : rowData[item.name] || ""
                                        }
                                        item={item.name}
                                        childHasError={(bool) =>
                                          setRowHasError(bool)
                                        }
                                        error={item?.error || ""}
                                        validation={handleValidate}
                                        readonly={mode}
                                      />
                                    </div>
                                    {/* ACTION BUTTON */}
                                    {!mode && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "5px",
                                          backgroundColor: "white",
                                          padding: "4px 8px 2px 8px",
                                          borderRadius: "4px",
                                          height: "35px",
                                          marginTop: "2px",
                                          cursor:
                                            mapColumnState?.[item.name]?.key &&
                                            Object.keys(
                                              mapColumnState?.[item.name]
                                                ?.key || {},
                                            ).length > 0 &&
                                            mapColumnState?.[item.name]?.value
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() =>
                                          removeAttributeFromObjectTypeCol(
                                            attribute,
                                            item.name,
                                          )
                                        }
                                      >
                                        <div>
                                          <i
                                            className="material-icons-outlined "
                                            style={{
                                              color: "red",
                                              marginTop: "5px",
                                              fontWeight: "600",
                                              cursor: "pointer",
                                            }}
                                          >
                                            do_not_disturb_on
                                          </i>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              },
                            )}
                          {/* EXISTING ATTRIBUTE DROPDOWNS END */}

                          {/* NEW ATTRIBUTE DROPDOWNS START */}
                          {!mode && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "start",
                                gap: "8px",
                                marginLeft: "20px",
                                width: "580px",
                                height: "fit-content",
                              }}
                            >
                              {/* KEY */}
                              <div style={{ width: "100%" }}>
                                <Autocomplete
                                  disableClearable
                                  options={
                                    DROPDOWN_VALUES &&
                                    Object.keys(DROPDOWN_VALUES)?.length > 0 &&
                                    DROPDOWN_VALUES?.[item.name]?.keys?.length >
                                      0
                                      ? DROPDOWN_VALUES?.[item.name]?.keys?.map(
                                          (item) => ({
                                            label: item,
                                            value: item,
                                          }),
                                        ) || []
                                      : []
                                  }
                                  value={
                                    mapColumnState?.[item.name]?.key || null
                                  }
                                  onChange={(key, val) => {
                                    updateKeyForAddNewAttributeMethod(
                                      item.name,
                                      val,
                                    );
                                  }}
                                  getOptionLabel={(option) =>
                                    option.label || ""
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                  }
                                  renderOption={(
                                    props,
                                    option,
                                    { selected },
                                  ) => {
                                    return <li {...props}>{option.label}</li>;
                                  }}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                      <Chip
                                        key={option.value}
                                        label={option.label}
                                        {...getTagProps({ index })}
                                        size="small"
                                      />
                                    ))
                                  }
                                  sx={{
                                    fontSize: "13px", // base font size

                                    "& .MuiInputBase-root": {
                                      padding: "2px 10px 2px 10px",
                                      height: "45px",
                                      fontSize: "13px",

                                      // ✅ default border
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: mode ? "#cccccc" : "black",
                                      },

                                      // ✅ hover
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: mode
                                            ? "#cccccc"
                                            : "black",
                                        },

                                      // ✅ focus
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: mode
                                            ? "#cccccc"
                                            : "black",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                      fontSize: "14px",
                                    },
                                    "& .MuiAutocomplete-endAdornment": {
                                      top: "calc(100% - 22px)", // center the dropdown icon
                                    },
                                  }}
                                  slotProps={{
                                    popper: {
                                      sx: {
                                        "& .MuiAutocomplete-paper": {
                                          boxShadow:
                                            "0 2px 8px rgba(0,0,0,0.15)",
                                          borderRadius: "8px",
                                        },
                                        "& .MuiAutocomplete-listbox": {
                                          padding: "4px 0",
                                          fontSize: "12px",
                                        },
                                        "& .MuiAutocomplete-option": {
                                          padding: "4px 6px",
                                          margin: "0px 4px",
                                          borderRadius: "2px",
                                          cursor: "pointer",
                                          transition: "background 0.15s ease",
                                        },
                                        "& .MuiAutocomplete-option:hover": {
                                          backgroundColor: "#f0f0f0",
                                        },
                                        "& .MuiAutocomplete-option[aria-selected='true']":
                                          {
                                            backgroundColor:
                                              "transparent !important",
                                          },
                                        "& .MuiAutocomplete-option.Mui-focused":
                                          {
                                            backgroundColor:
                                              "#f5f5f5 !important",
                                          },
                                      },
                                    },
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      style={{ border: "none" }}
                                    />
                                  )}
                                />
                              </div>
                              <span style={{ width: "10px" }}>:</span>
                              {/* VALUE */}
                              <div style={{ width: "100%" }}>
                                <Input
                                  columnDataArr={rowData?.[item.name]}
                                  tableName={props.tableName}
                                  classes={{}}
                                  showLabel={false}
                                  label={item.label}
                                  type={item.type}
                                  name={item.name}
                                  onChange={(e) =>
                                    updateValueForAddNewAttributeMethod(
                                      item.name,
                                      e.target.value,
                                    )
                                  }
                                  value={
                                    mapColumnState?.[item.name]?.value || ""
                                  }
                                  item={item.name}
                                  childHasError={(bool) => setRowHasError(bool)}
                                  error={item?.error || ""}
                                  validation={handleValidate}
                                  readonly={mode}
                                />
                              </div>
                              {/* ACTION BUTTON */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "5px",
                                  backgroundColor: "#46596a",
                                  padding: "4px 8px 2px 8px",
                                  borderRadius: "4px",
                                  height: "35px",
                                  marginTop: "2px",
                                  cursor:
                                    mapColumnState?.[item.name]?.key &&
                                    Object.keys(
                                      mapColumnState?.[item.name]?.key || {},
                                    ).length > 0 &&
                                    mapColumnState?.[item.name]?.value
                                      ? "pointer"
                                      : "not-allowed",
                                }}
                                onClick={() => {
                                  addNewAttributeToObjectTypeCol(0, item.name);
                                }}
                              >
                                <div>
                                  <i
                                    className="material-icons-outlined "
                                    style={{
                                      color: "white",
                                      marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    add_circle
                                  </i>
                                </div>
                                <div
                                  style={{
                                    color: "white",
                                    fontSize: "13px",
                                  }}
                                >
                                  Add
                                </div>
                              </div>
                            </div>
                          )}
                          {/* NEW ATTRIBUTE DROPDOWNS END*/}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {mode ? (
            <>
              <Button onClick={handleEdit}>Edit</Button>
            </>
          ) : (
            <Button onClick={handleSave} disabled={isRowDataUpdating}>
              {isRowDataUpdating ? "Saving" : "Save"}
            </Button>
          )}
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
